// const measurements = [
//   'paddingLeft',
//   'paddingRight',
//   'paddingTop',
//   'paddingBottom',
//   'marginLeft',
//   'marginRight',
//   'marginTop',
//   'marginBottom',
//   'borderLeftWidth',
//   'borderRightWidth',
//   'borderTopWidth',
//   'borderBottomWidth',
// ];
// type MeasurementKeys = typeof measurements[number] | 'width' | 'height' | 'innerWidth' | 'innerHeight' | 'outerWidth' | 'outerHeight';

type SizeType = {
  width: number,
  height: number,
  innerWidth: number,
  innerHeight: number,
  outerWidth: number,
  outerHeight: number,
  paddingLeft: number,
  paddingRight: number,
  paddingTop: number,
  paddingBottom: number,
  marginLeft: number,
  marginRight: number,
  marginTop: number,
  marginBottom: number,
  borderLeftWidth: number,
  borderRightWidth: number,
  borderTopWidth: number,
  borderBottomWidth: number,
  isBorderBox: boolean;
}

const measurements: Array<keyof SizeType> = [
  'paddingLeft',
  'paddingRight',
  'paddingTop',
  'paddingBottom',
  'marginLeft',
  'marginRight',
  'marginTop',
  'marginBottom',
  'borderLeftWidth',
  'borderRightWidth',
  'borderTopWidth',
  'borderBottomWidth',
];

function getStyleSize (value: string) {
  let num = parseFloat(value);
  // not a percent like '100%', and a number
  let isValid = value.indexOf('%') == -1 && !isNaN(num);
  return isValid && num;
}

const getZeroSize = () => {
  let size = {
    width: 0,
    height: 0,
    innerWidth: 0,
    innerHeight: 0,
    outerWidth: 0,
    outerHeight: 0,
    paddingLeft: 0,
    paddingRight: 0,
    paddingTop: 0,
    paddingBottom: 0,
    marginLeft: 0,
    marginRight: 0,
    marginTop: 0,
    marginBottom: 0,
    borderLeftWidth: 0,
    borderRightWidth: 0,
    borderTopWidth: 0,
    borderBottomWidth: 0,
    isBorderBox: false
  };
  return size;
}

export const getSize = (elem: HTMLElement) => {
  let style = getComputedStyle(elem);


  //@ts-ignore
  const size: SizeType = {
    width: elem.offsetWidth,
    height: elem.offsetHeight,
    innerWidth: 0,
    innerHeight: 0,
    outerWidth: 0,
    outerHeight: 0,
    paddingLeft: 0,
    paddingRight: 0,
    paddingTop: 0,
    paddingBottom: 0,
    marginLeft: 0,
    marginRight: 0,
    marginTop: 0,
    marginBottom: 0,
    borderLeftWidth: 0,
    borderRightWidth: 0,
    borderTopWidth: 0,
    borderBottomWidth: 0,
    isBorderBox: false
  };
  size.width = elem.offsetWidth;
  size.height = elem.offsetHeight;

  let isBorderBox = size.isBorderBox = style.boxSizing == 'border-box';

  if (style.display == 'none') return getZeroSize();

  measurements.forEach((measurement) => {
    //@ts-ignore
    let value = style[measurement];
    let num = parseFloat(value);
    //@ts-ignore
    size[measurement] = !isNaN(num) ? num : 0;
  });

  let paddingWidth = size.paddingLeft + size.paddingRight;
  let paddingHeight = size.paddingTop + size.paddingBottom;
  let marginWidth = size.marginLeft + size.marginRight;
  let marginHeight = size.marginTop + size.marginBottom;
  let borderWidth = size.borderLeftWidth + size.borderRightWidth;
  let borderHeight = size.borderTopWidth + size.borderBottomWidth;

  let styleWidth = getStyleSize(style.width);
  if (styleWidth !== false) {
    size.width = styleWidth +
      // 添加边框宽度
      (isBorderBox ? 0 : paddingWidth + borderWidth);
  }

  let styleHeight = getStyleSize(style.height);
  if (styleHeight !== false) {
    size.height = styleHeight +
      // 添加边框高度
      (isBorderBox ? 0 : paddingHeight + borderHeight);
  }

  size.innerWidth = size.width - (paddingWidth + borderWidth);
  size.innerHeight = size.height - (paddingHeight + borderHeight);

  size.outerWidth = size.width + marginWidth;
  size.outerHeight = size.height + marginHeight;


  return size;
}